export default {
    'name': 'pause_l',
    'width': '123',
    'height': '123',
    'viewBox': '0 0 123 123',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M36.0476 30H49.7619C51.4451 30 52.8095 31.3024 52.8095 32.9091V91.0909C52.8095 92.6976 51.4451 94 49.7619 94H36.0476C34.3645 94 33 92.6976 33 91.0909V32.9091C33 31.3024 34.3645 30 36.0476 30ZM74.1429 30H87.8572C89.5403 30 90.9048 31.3024 90.9048 32.9091V91.0909C90.9048 92.6976 89.5403 94 87.8572 94H74.1429C72.4597 94 71.0953 92.6976 71.0953 91.0909V32.9091C71.0953 31.3024 72.4597 30 74.1429 30Z\' fill=\'#FF4171\'/>'
}
